define('extensions/uv-seadragon-extension/DownloadType',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DownloadType;
    (function (DownloadType) {
        DownloadType["CURRENTVIEW"] = "currentView";
        DownloadType["ENTIREDOCUMENTASPDF"] = "entireDocumentAsPdf";
        DownloadType["ENTIREDOCUMENTASTEXT"] = "entireDocumentAsText";
        DownloadType["WHOLEIMAGEHIGHRES"] = "wholeImageHighRes";
        DownloadType["WHOLEIMAGESHIGHRES"] = "wholeImageHighRes";
        DownloadType["WHOLEIMAGELOWRES"] = "wholeImageLowRes";
        DownloadType["UNKNOWN"] = "unknown";
    })(DownloadType = exports.DownloadType || (exports.DownloadType = {}));
});
//# sourceMappingURL=DownloadType.js.map
